import { render, staticRenderFns } from "./PlayerNoticeView.vue?vue&type=template&id=961b6f16&"
import script from "./PlayerNoticeView.vue?vue&type=script&lang=js&"
export * from "./PlayerNoticeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports